import type { GetUpcomingInvoicesReportResponsePayload } from '@vy/api-definition';
import { GetUpcomingInvoicesReportResponseSchema } from '@vy/api-definition';
import { validateNotNullOrUndefined } from '@vy/utils';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

async function fetchUpcomingInvoicesReport() {
  const api = getPrivateApi();
  const reportResponse = await api.getUpcomingInvoicesReport();

  return GetUpcomingInvoicesReportResponseSchema.parse(reportResponse);
}

export function useUpcomingInvoicesReport(
  options?: CustomUseQueryOptions<GetUpcomingInvoicesReportResponsePayload>,
) {
  const upcomingInvoicesReportQuery = useQuery(
    queryKeys.upcomingInvoicesReport(),
    () => fetchUpcomingInvoicesReport(),
    {
      suspense: true,
      ...options,
    },
  );

  validateNotNullOrUndefined(upcomingInvoicesReportQuery.data, 'upcomingInvoicesReportQuery data');

  return upcomingInvoicesReportQuery;
}

